import application from 'stimulus_application';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import './content_cta_block.css';

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));

// FIXME: background image
